export default function getResource(label, vars = []) {
    const resources = {
        codesExhaustedHeading: 'Tous les codes promotionnels disponibles ont été réclamés',
        codesExhaustedBody: 'Entre-temps, vous pouvez vous connecter ou créer un compte pour profiter des autres offres de Sephora',
        shopNow: 'Magasiner',
        promotionEndedHeading: 'This offer has ended.',
        promotionEndedBody: 'But since you’re here enjoy more offers from Sephora.',
        alreadyRegisteredHeading: `You have already signed up for your ${vars[0]} off!`,
        alreadyRegisteredBody: 'Check your email for details.'
    };

    return resources[label];
}
